import { render, staticRenderFns } from "./integratedMachine.vue?vue&type=template&id=1a060d11&scoped=true&"
import script from "./integratedMachine.vue?vue&type=script&lang=js&"
export * from "./integratedMachine.vue?vue&type=script&lang=js&"
import style0 from "./integratedMachine.vue?vue&type=style&index=0&id=1a060d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a060d11",
  null
  
)

export default component.exports